export default __webpack_public_path__ + "static/Ryandina Ayusavitri-fc1ba0497585aece680c44c293721bf8.png";